import React from "react";
import { Link } from "react-router-dom";

const Footer = (props) => {
    return (
        <footer id="footer">
            {/* <div className="footer-newsletter">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">
                            <h4>Join Our Newsletter</h4>
                            <p>
                                Tamen quem nulla quae legam multos aute sint
                                culpa legam noster magna
                            </p>
                            <form action="" method="post">
                                <input type="email" name="email" />
                                <input type="submit" value="Subscribe" />
                            </form>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* <div className="footer-top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 footer-contact">
                            <h3>ExpenseGenie</h3>
                            <p>
                                New Ranip, Ahmedabad.
                                <br />
                                Gujarat, India <br /><br />
                                <strong>Phone:</strong> <a href="tel:+918849620406">+91 88496 20406</a>
                                <br />
                                <strong>Email:</strong>  <a href="mailto:coderman401.ai@gmail.com">coderman401.ai@gmail.com</a>
                                <br />
                            </p>
                        </div>

                        <div className="col-lg-3 col-md-6 footer-links">
                            <h4>Useful Links</h4>
                            <ul>
                                <li>
                                    <i className="bx bx-chevron-right"></i>{" "}
                                    <Link to="/">Home</Link>
                                </li>
                                <li>
                                    <i className="bx bx-chevron-right"></i>{" "}
                                    <Link to="/">About us</Link>
                                </li>
                                <li>
                                    <i className="bx bx-chevron-right"></i>{" "}
                                    <Link to="/">Services</Link>
                                </li>
                                <li>
                                    <i className="bx bx-chevron-right"></i>{" "}
                                    <Link to='/privacy-policy'>Privacy Policy</Link>
                                </li>
                                <li>
                                    <i className="bx bx-chevron-right"></i>{" "}
                                    <Link to='/privacy-policy'>Terms of Service</Link>
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-3 col-md-6 footer-links">
                            <h4>Our Services</h4>
                            <ul>
                                <li>
                                    <i className="bx bx-chevron-right"></i>{" "}
                                    <Link to="/">Web Design</Link>
                                </li>
                                <li>
                                    <i className="bx bx-chevron-right"></i>{" "}
                                    <Link to="/">Web Development</Link>
                                </li>
                                <li>
                                    <i className="bx bx-chevron-right"></i>{" "}
                                    <Link to="/">Product Management</Link>
                                </li>
                                <li>
                                    <i className="bx bx-chevron-right"></i>{" "}
                                    <Link to="/">Marketing</Link>
                                </li>
                                <li>
                                    <i className="bx bx-chevron-right"></i>{" "}
                                    <Link to="/">Graphic Design</Link>
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-3 col-md-6 footer-links">
                            <h4>Our Social Networks</h4>
                            <div className="social-links mt-3">
                                <a href="https://www.twitter.com/coderman401" className="twitter">
                                    <i className="bx bxl-twitter"></i>
                                </a>
                                <a href="https://www.facebook.com/coderman401/" className="facebook">
                                    <i className="bx bxl-facebook"></i>
                                </a>
                                <a href="https://www.instagram.com/coderman401/" className="instagram">
                                    <i className="bx bxl-instagram"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="container">
                <div className="copyright">
                    &copy; Copyright{" "}
                    <strong>
                        <span>ExpenseGenie</span>
                    </strong>
                    . All Rights Reserved
                </div>
                <div className="credits">
                    <Link to="/privacy-policy">Privacy Policy</Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
